var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1213_21182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0H4.5C3.8372 0.000793929 3.20178 0.264441 2.73311 0.73311C2.26444 1.20178 2.00079 1.8372 2 2.5V8H10V2.5C9.99921 1.8372 9.73556 1.20178 9.26689 0.73311C8.79822 0.264441 8.1628 0.000793929 7.5 0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9.5C2.00079 10.1628 2.26444 10.7982 2.73311 11.2669C3.20178 11.7356 3.8372 11.9992 4.5 12H7.5C8.1628 11.9992 8.79822 11.7356 9.26689 11.2669C9.73556 10.7982 9.99921 10.1628 10 9.5V9H2V9.5ZM6 10C6.09889 10 6.19556 10.0293 6.27779 10.0843C6.36001 10.1392 6.4241 10.2173 6.46194 10.3087C6.49978 10.4 6.50969 10.5006 6.49039 10.5975C6.4711 10.6945 6.42348 10.7836 6.35355 10.8536C6.28363 10.9235 6.19454 10.9711 6.09755 10.9904C6.00055 11.0097 5.90002 10.9998 5.80866 10.9619C5.7173 10.9241 5.63921 10.86 5.58427 10.7778C5.52932 10.6956 5.5 10.5989 5.5 10.5C5.5 10.3674 5.55268 10.2402 5.64645 10.1464C5.74021 10.0527 5.86739 10 6 10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1213_21182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phone-white.c1c99bf43f41f65e86251f7a750ca2ee.svg";
export { ForwardRef as ReactComponent };